import React from 'react'
import { Icon } from '@gymondo/frontend-core/components'
import logoBlack from '@gymondo/frontend-core/svg/logo-black.svg'

import { LOGO_VARIANTS } from '../utils'
import logoPrideMonth from './assets/pride-month-logo.svg'
import gymBarmer from './assets/gym-barmer.png'

import style from './logo.module.scss'

export const ciLogo = <Icon data={logoBlack} className="gym-logo__svg--ci" />
export const prideLogo = (
    <Icon data={logoPrideMonth} className="gym-logo__svg--ci" />
)

export const gymBarmerLogo = (
    <img src={gymBarmer} alt="Gymondo & Barmer" className={style.barmer} />
)

export const LOGO_INITIAL_COMPONENT_MAP = {
    [LOGO_VARIANTS.CI]: () => ciLogo,
    [LOGO_VARIANTS.PRIDE]: () => prideLogo,
    [LOGO_VARIANTS.GYM_AND_BARMER]: () => gymBarmerLogo,
}

export const getInitialLogoComponent = (logoVariant, isGermanLangauge) => {
    return (
        LOGO_INITIAL_COMPONENT_MAP[logoVariant]?.(isGermanLangauge) || undefined
    )
}
